'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var moment = _interopDefault(require('moment'));
var calendarWrapper = require('./calendar-wrapper-00f60b01.js');
var styles$e = require('./styles-64b3a95d.js');

var useMonthPicker = function (value, paperRef) {
    var initialMonths = React.useMemo(function () {
        var selectedMonth = moment(value);
        var monthArray = [selectedMonth];
        for (var monthIndex = 1; monthIndex <= 12; monthIndex += 1) {
            monthArray.unshift(selectedMonth.clone().subtract(monthIndex, 'months'));
            monthArray.push(selectedMonth.clone().add(monthIndex, 'months'));
        }
        return monthArray;
    }, [value]);
    var _a = tslib_es6.__read(React.useState(initialMonths), 2), months = _a[0], setMonths = _a[1];
    var onTopHit = React.useCallback(function (element) {
        var additionalMonths = [];
        for (var monthIndex = 1; monthIndex <= 12; monthIndex += 1) {
            additionalMonths.unshift(months[0].clone().subtract(monthIndex, 'months'));
        }
        setMonths(tslib_es6.__spread(additionalMonths, months));
        element.scrollTo(0, 1);
    }, [months]);
    var onBottomHit = React.useCallback(function () {
        var additionalMonths = [];
        for (var monthIndex = 1; monthIndex <= 12; monthIndex += 1) {
            additionalMonths.push(months[months.length - 1].clone().add(monthIndex, 'months'));
        }
        setMonths(tslib_es6.__spread(months, additionalMonths));
    }, [months]);
    var onScroll = React.useCallback(function () {
        if (paperRef.current) {
            var element = (paperRef.current);
            var scrollTop = element.scrollTop, scrollHeight = element.scrollHeight, clientHeight = element.clientHeight;
            if (scrollTop === 0) {
                onTopHit(element);
            }
            if (scrollTop + clientHeight === scrollHeight) {
                onBottomHit();
            }
        }
    }, [onBottomHit, onTopHit, paperRef]);
    return {
        months: months,
        onScroll: onScroll,
    };
};

var MonthPicker = function (_a) {
    var value = _a.value, isModalOpen = _a.isModalOpen, onClose = _a.onClose, onClick = _a.onClick, label = _a.label, isFlexStyle = _a.isFlexStyle, setValue = _a.setValue;
    var paperRef = React.useRef(null);
    var _b = useMonthPicker(value, paperRef), months = _b.months, onScroll = _b.onScroll;
    var currentMonth = React.useRef(null);
    React.useEffect(function () {
        if (isModalOpen && currentMonth && currentMonth.current) {
            (currentMonth.current).scrollIntoView({ block: 'center' });
        }
    }, [isModalOpen, currentMonth]);
    return (React__default.createElement(calendarWrapper.CalendarWrapper, { value: value, open: isModalOpen, hide: onClose, toggle: onClick, label: label, isFlexStyle: isFlexStyle, isMonthPicker: true, paperRef: paperRef, onScroll: onScroll }, months.map(function (month) {
        function onItemClick() {
            setValue(month);
        }
        return (React__default.createElement(styles$e.MonthPickerItem, { ref: (value === null || value === void 0 ? void 0 : value.isSame(month)) ? currentMonth : null, key: month.toISOString(), isSelected: value === null || value === void 0 ? void 0 : value.isSame(month), onClick: onItemClick }, month.format('MMM, YYYY')));
    })));
};

exports.MonthPicker = MonthPicker;
